import React from "react";
import { FaArrowUp } from "react-icons/fa"; // Импорт иконки

function Footer() {
  return (
    <footer className="footer">
      <button
        className="footer__up"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      >
        <FaArrowUp />
      </button>

      <div className="footer__social">
        <a href="">TELEGRAM</a>
        <a href="">INSTAGRAM</a>
      </div>

      <div className="footer__bottom">
        <span className="footer__copyright">2025 © All rights reserved</span>
        <div className="footer__links">
          <a href="">Політика конфіденційності</a>
          <a href="">Умови використання</a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
